var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-12 text-center"},[_c('h1',{staticClass:"font-weight-light mb-2 headline"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('span',{staticClass:"font-weight-light subtitle-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }